<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <dynamic-input v-for="form in forms" :key="form.id" :type="form.form_khusus.tipe" :name="form.form_khusus.nama" :label="form.form_khusus.label" :meta="form.form_khusus.meta_data" @d-input-change="handleInputChange" />
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import DynamicInput from '@/components/DynamicInput'

export default {
  data () {
    return {
      init: false,
      loading: false,
      sending: false,
      model: {},
      savedModel: null
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  computed: {
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    kodePenawaran () {
      return this.$store.getters.getAuthData.data.mhs_jalur.kode_penawaran
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(99).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    },
    forms () {
      return this.$store.state.formData.formKhusus
    }
  },
  components: {
    'dynamic-input': DynamicInput
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$root.$emit('input-khusus-validate')
        let nullExist = false
        Object.keys(this.model).forEach((key, i) => {
          if (!this.model[key]) {
            nullExist = true
          }
        })
        if (nullExist) {
          reject({message: 'isian belum lengkap'})
        } else {
          resolve(true)
        }
      })
    },
    initData () {
      // Doing Something Here
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/data_khusus', {
              nomor_pendaftar: this.nomorPendaftar,
              meta_data: this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    },
    handleInputChange (meta) {
      this.model[meta.name] = meta.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataKhusus.vue